import {
  Component,
  OnChanges,
  Input,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';

import { TableComponent } from 'shared/table/table/table.component';

@Component({
  moduleId: module.id,
  selector: 'preferences-form',
  templateUrl: 'preferences-form.component.html',
  styleUrls: ['preferences-form.component.scss'],
})

export class PreferencesFormComponent extends TableComponent implements OnChanges {
  form: UntypedFormGroup;

  @Input() segmentData: Array<any> = [];

  @Input() declare data: any;

  // public:
  constructor(
    private fb: UntypedFormBuilder
  ) {
    super();
  }

  // hooks
  ngOnChanges(changes: any) {
    if (this.form) {
      this.updateForm();
    } else {
      this.createForm();
    }
  }

  // public
  createForm() {
    const formControls = this.createFormItem(this.data);
    this.form = this.fb.group(formControls);
  }


  // private
  private createFormItem(obj: any = {}): any {
    return _.reduce(this.segmentData, (result: any, item: any) => {
      const control = new UntypedFormControl(obj[item.item_name], this.getItemValidators(item.validation));
      result[item.field_map] = control;
      return result;
    }, {});
  }

  private updateForm(): void {
    _.each(this.segmentData, (item: any) => {
      const control = this.form.get(item.field_map);
      if (this.data[item.item_name] && control) {
        if (control) { control.setValue(this.data[item.item_name]); }
      } else {
        // if preferences wasn't set yet
        if (control) {
          switch (item.item_name) {
            case 'timezone':
              const guessedTZ = moment.tz.guess();
              control.setValue(guessedTZ);
              break;
          }
        }
      }
    });
  }
}
